import React, { memo, useContext } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router';
import queryString from 'querystring';
import { AppContext } from '@prisjakt/ui-app-context';
import ArrowIcon from 'mdi-react/ChevronRightIcon';
import { ShowAllLink } from './styles';

const getQueryString = history =>
  queryString.decode(history.location.search.substr(1));

const getLink = (query, history) => {
  const qs = getQueryString(history);

  qs.q = query;
  delete qs.search;

  const qsEncoded = queryString.encode(qs);
  return `/search?${qsEncoded}`;
};

const ShowAll = ({ onClick, styling, query, history }) => {
  const { t } = useContext(AppContext);
  return (
    <ShowAllLink
      onClick={onClick}
      richText={styling === 'rich'}
      to={getLink(query, history)}
    >
      <span>{t('search', 'results.show-all-button')}</span>
      <ArrowIcon right />
    </ShowAllLink>
  );
};

const { string, func, object } = PropTypes;

ShowAll.propTypes = {
  query: string.isRequired,
  styling: string.isRequired,
  history: object.isRequired,
  onClick: func,
};

ShowAll.defaultProps = {
  onClick: () => {},
};

export default memo(withRouter(ShowAll));
